import { SEGMENTS, VALID_PRICES } from '../../data/conjointData';
import { formatPercent, formatNumber, formatPrice } from '../../lib/formatters';
import { Users } from 'lucide-react';
import { InfoButton } from '../common/Tooltip';
import { LineChart, Line, ResponsiveContainer, ReferenceDot } from 'recharts';

interface Props {
  selectedPrice?: number;
}

export function SegmentOverviewCards({ selectedPrice }: Props) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {SEGMENTS.map(seg => {
        const sparkData = VALID_PRICES.map(p => ({ price: p, rate: (seg.priceCurve[p] ?? 0) * 100 }));
        const atPriceRate = selectedPrice ? (seg.priceCurve[selectedPrice] ?? 0) : null;
        const selectedDot = selectedPrice ? sparkData.find(d => d.price === selectedPrice) : null;

        return (
          <div key={seg.name} className="card" style={{ borderLeftColor: seg.color, borderLeftWidth: 3 }}>
            <div className="flex items-start justify-between mb-3">
              <div>
                <h4 className="text-sm font-bold text-primary">{seg.name}</h4>
                <p className="text-sm text-muted mt-0.5">{seg.characterization}</p>
              </div>
              <Users size={16} style={{ color: seg.color }} />
            </div>
            <div className={`grid ${selectedPrice ? 'grid-cols-3' : 'grid-cols-2'} gap-3 mb-3`}>
              <div>
                <div className="text-xs text-muted uppercase">Size</div>
                <div className="font-mono text-sm text-primary">{formatNumber(seg.size)} ({formatPercent(seg.percentage, 1)})</div>
              </div>
              <div>
                <div className="text-xs text-muted uppercase flex items-center gap-1">Purchase Resistance <InfoButton helpKey="avgNoneUtility" size={10} /></div>
                <div className="font-mono text-sm text-primary">{seg.avgNoneUtility.toFixed(4)}</div>
              </div>
              {selectedPrice && atPriceRate !== null && (
                <div>
                  <div className="text-xs text-muted uppercase">At {formatPrice(selectedPrice)}</div>
                  <div className="font-mono text-sm font-semibold" style={{ color: seg.color }}>{formatPercent(atPriceRate)}</div>
                </div>
              )}
            </div>
            <div className="h-12">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={sparkData}>
                  <Line type="monotone" dataKey="rate" stroke={seg.color} strokeWidth={2} dot={false} />
                  {selectedDot && (
                    <ReferenceDot
                      x={selectedDot.price}
                      y={selectedDot.rate}
                      r={5}
                      fill={seg.color}
                      stroke="var(--color-card)"
                      strokeWidth={2}
                    />
                  )}
                </LineChart>
              </ResponsiveContainer>
            </div>
            <div className="flex justify-between text-xs text-muted font-mono mt-0.5"><span>$499</span><span>$1,899</span></div>
          </div>
        );
      })}
    </div>
  );
}
